export default function Cart() {
    return (
        <div>
          <h1 className="text-center text-4xl bg-black py-2 mb-8 text-white">Cart</h1>
        </div>
      );
}
